"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.styles = function (_a) {
  var sizeBorderWidth = _a.sizeBorderWidth,
      colorDivider = _a.colorDivider,
      colorBg = _a.colorBg,
      x5 = _a.x5,
      x20 = _a.x20;
  return {
    navigationMenu: {
      display: 'flex',
      height: '100%',
      flexDirection: 'column',
      width: x20 * 3,
      flex: '1 0 auto',
      background: colorBg.normal
    },
    fluid: {
      width: '100%'
    },
    header: {
      borderRight: sizeBorderWidth + "px solid " + colorDivider.normal,
      minHeight: x5,
      flexShrink: 0
    },
    body: {
      borderRight: sizeBorderWidth + "px solid " + colorDivider.normal,
      flexGrow: 1
    },
    footer: {
      borderRight: sizeBorderWidth + "px solid " + colorDivider.normal,
      minHeight: x5,
      display: 'flex',
      alignItems: 'center',
      paddingTop: x5,
      paddingBottom: x5,
      marginLeft: 0,
      marginRight: 0,
      flexShrink: 0
    }
  };
};